import { useState } from 'react';
import { toast } from 'sonner';
import { admin, apiErrorMessage, type AdminCertProfileItem } from '../../lib/api';
import { useApi } from '../../hooks/useApi';
import { useTranslation } from '../../i18n';
import { DataTable, Button, type Column } from '../../components/ui';
import { useAdminT } from './adminI18n';

export default function AdminCertProfilesPage() {
  const t = useAdminT();
  const { t: gt } = useTranslation();
  const [refreshKey, setRefreshKey] = useState(0);
  const [busyId, setBusyId] = useState<string | null>(null);

  const q = useApi(() => admin.certProfiles(), [refreshKey]);
  const rows = q.status === 'success' ? q.data : [];

  async function toggle(r: AdminCertProfileItem) {
    setBusyId(r.id);
    try {
      await admin.updateCertProfile(r.id, { is_active: !r.is_active });
      toast.success(t('cprof.toggled'));
      setRefreshKey((k) => k + 1);
    } catch (err) {
      toast.error(apiErrorMessage(err, gt));
    } finally {
      setBusyId(null);
    }
  }

  const columns: Column<AdminCertProfileItem>[] = [
    { key: 'name', header: t('col.name'), render: (r) => r.name },
    { key: 'description', header: t('reports.detail'), render: (r) => r.description ?? '—' },
    { key: 'is_default', header: t('cprof.default'), width: '70px', render: (r) => (r.is_default ? '★' : '—') },
    { key: 'is_system', header: t('cprof.system'), width: '80px', render: (r) => (r.is_system ? '✓' : '—') },
    { key: 'is_active', header: t('cprof.active'), width: '120px',
      render: (r) => (
        <Button size="sm" variant={r.is_active ? 'secondary' : 'accent'}
          disabled={busyId === r.id} onClick={() => toggle(r)}>
          {r.is_active ? t('cprof.active') : '—'}
        </Button>
      ) },
  ];

  return (
    <div className="admin-page">
      <header className="admin-page__head">
        <h1>{t('cprof.title')}</h1>
        <p className="admin-page__sub">{t('cprof.subtitle')}</p>
      </header>
      <DataTable columns={columns} rows={rows} rowKey={(r) => r.id}
        loading={q.status === 'loading'} empty={t('emptyGeneric')} />
    </div>
  );
}
